import React, { useState } from 'react'
import PageBody from 'Common/Custom/PageBody'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import ZoneTypeListTable from './Components/ZoneTypeListTable'
import { useRoleVerify } from 'Common/RoleVerify'
import AddZoneType from '../AddZoneType/AddZoneType'

const ZoneTypeList = () => {
    const [refetch, setRefetch] = useState(false)
    const canShowAction = useRoleVerify("", ["can_create"]);
    return (
        <>
            {canShowAction &&
                <AddZoneType
                    setRefetch={setRefetch}
                    refetch={refetch}
                />}

            <PageBody
                card={true}
                headerchildren={
                    <>
                        <HeadingOne>Zone Type List</HeadingOne>
                    </>
                }>

                {/* Table section */}
                <div className="col-12">
                    <ZoneTypeListTable refetch={refetch} />
                </div>
            </PageBody>
        </>
    )
}

export default ZoneTypeList
